var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "emd-card-grid__row" },
    [
      _c("Bank", {
        attrs: {
          title: _vm.$t("charge.detail.payment-method.bank-transfer.bank"),
          bank: _vm.lastTransaction.bank,
        },
      }),
      _c("TId", {
        attrs: {
          title: _vm.$t("charge.detail.payment-method.bank-transfer.tid"),
          "t-id": _vm.lastTransaction.bank_tid,
        },
      }),
      _c("DetailAt", {
        attrs: { "updated-at": _vm.updatedAt, "created-at": _vm.createdAt },
      }),
      _vm.dueAt
        ? _c("DueAt", {
            attrs: {
              title: _vm.$t(
                "charge.detail.payment-method.bank-transfer.due-at"
              ),
              dueAt: _vm.due,
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }